var map = {
	"./Birthday-Cake.jpg": 6491,
	"./Chocolate-Fully-Iced.jpg": 2782,
	"./Double-Fudge.jpg": 4486,
	"./Icing.jpg": 7803,
	"./M&M.jpg": 1629,
	"./Oatmeal-Walnut-Raisin copy.jpg": 9882,
	"./Oatmeal-Walnut-Raisin.jpg": 9185,
	"./Original-Chocolate-Chip.jpg": 4076,
	"./Sugar-Cake.jpg": 6680,
	"./Vanilla-Fully-Iced.jpg": 7655,
	"./m-birthday-cake-mm.jpg": 9010,
	"./m-double-fudge-mm.jpg": 4853,
	"./m-oatmeal-walnut-raisin-mm.jpg": 4180,
	"./m-original-chocolate-chip-mm.jpg": 4479,
	"./m-sugar-cake-mm.jpg": 919
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6803;